export const LABEL_MODAL_BUTTON = "Список";
export const LABEL_SHOP_SEARCH_PLACEHOLDER = "Найти магазин по адресу";
export const LABEL_SHOP_ALL = "Все магазины";
export const LABEL_SHOP_REGULAR = "Магнит у дома";
export const LABEL_SHOP_COSMETIC = "Магнит Косметик";
export const LABEL_SHOP_APTEKA = "Магнит Аптека";
export const LABEL_SHOP_FAMILY = "Магнит Семейный";
export const LABEL_SHOP_EXTRA = "Магнит Экстра";
export const LABEL_SHOP_MASTER = "Магнит Мастер";
export const LABEL_SHOP_WHOLESALE = "Гипермаркет Магнит";
export const LABEL_SHOP_V1 = "Первый выбор";
export const LABEL_SHOP_MYPRICE = "Моя цена";
export const LABEL_SHOP_UNKNOWN = "Неизвестный формат";
export const LABEL_SELECT_SHOP_ACTION = "Выбрать";
export const LABEL_CANCEL = "Отмена";
export const LABEL_LOADING_ERROR = "При загрузке данных произошла ошибка";
export const LABEL_EMPTY_LIST_TITLE = "Ничего не нашлось";
export const LABEL_EMPTY_LIST_DESC_SHOPS =
  "Попробуйте изменить запрос или выберите магазин из списка";
export const LABEL_SELECTED_SHOP_TITLE = "Выбранный магазин";
export const LABEL_LIST_SHOPS_TITLE = "Магазины на карте";
export const LABEL_LIST_SHOPS_SEARCH_TITLE = "Результаты поиска";
